import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text23 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {rightsChain} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(rightsChain) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={styles.bold}>שרשור זכויות: </span>
          <span>{getBreakLinesTextShumaType3(rightsChain)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text23;
